module.exports = __webpack_public_path__ + "img/H-B-4-unload-standup-shadow.733ff9ab.png";